<div [formGroup]="parentForm" class="standard-form-field">
  <div class="field-label">
    <label for="{{inputId}}" [ngClass]="getFormControl()?.dirty && !getFormControl()?.valid ? 'title text-error' : 'title'">
      {{label | translate}}@if (required){<span class="">*</span>}
    </label>
  </div>

  <div class="input-wrap">

    <input id="{{inputId}}" [type]="fieldTextType ? 'text' : 'password'" class="forgot-input"
           [formControlName]="controlName" (focus)="onFocus()" (blur)="onBlur()"
           [ngClass]="(getFormControl()?.dirty && !getFormControl()?.valid)? 'crc-input-text-error':''" />

    @if (!hasFocus && getFormControl()?.dirty && !getFormControl()?.valid) {
      <img class="icons-alert-circle" src="assets/images/alert-circle.svg" alt="Password error" />
    } @else {
      <img class="eye-icon icons-eye" (mousedown)="onTogglePasswordMouseDown($event)"
           src="{{fieldTextType ?'assets/images/eye-off.svg':'assets/images/eye.svg'}}" alt="Show password"/>
    }
  </div>

</div>

